import { connect } from "react-redux";
import Price from "../Common/Price";

const DomesticHotelDetailSafarmarketRateItem = props => {

  const { rate, duration, Dictionary } = props;

  const room = props.availabilityItem?.rooms[0];

  const isSelectedRoom = props.selectedRoomToken && props.selectedRoomToken === rate.bookingToken;

  const prices = {
    roomPrice: rate.pricing.find((item) => item.type === 'Room' && item.ageCategoryType === 'ADL')?.amount,
    boardPrice: rate.pricing.find((item) => item.type === 'RoomBoard' && item.ageCategoryType === 'ADL')?.amount,
    extraBedPrice: rate.pricing.find((item) => item.type === 'ExtraBed' && item.ageCategoryType === 'ADL')?.amount,
    childPrice: rate.pricing.find((item) => item.type === 'Room' && item.ageCategoryType === 'CHD')?.amount,
  };

  let capacity = null;
  if (room.capacity?.count) {
    capacity = <div className="font-12 sm-font-14 room-capacity">
      <div className="block medium-inline-block margin-bottom-light">
        <span className="itours-icon guests-dark margin-end-light icon-small" />
        <span className="margin-end-light">ظرفیت: </span>
        <span className="inline-block margin-end">
          {room.capacity.count} نفر
        </span>
      </div>
      {!!room.capacity.extraBed && room.capacity.extraBed > 0 && <div className="block medium-inline-block margin-bottom-light">

        <span className="itours-icon hotel-dark margin-end-light icon-small" />
        <span className="margin-end-light">تخت اضافه: </span>
        <span className="inline-block margin-end-light">
          {room.capacity.extraBed}  عدد
        </span>

        {!!prices.extraBedPrice && (
          <>
            (
            <span className="margin-end-light">{Dictionary.ExtraBedPrice}:</span>

            <Price currency={props.currency}>
              {prices.extraBedPrice}
            </Price>
            )

          </>
        )}
      </div>}
    </div>
  }

  return (
    <>
      {(
        (props.availabilityIndex === 0 && props.rateIndex === 1)
        ||
        (props.availabilityItem.rates.length === 1 && props.availabilityIndex === 1 && props.rateIndex === 0)
      ) && <h5 className="normal-title no-select-highlight">سایر اتاق های این هتل</h5>}

      <div className="margin-bottom bg-white rounded-medium">
        <div className="border-bottom">
          <div className="card-padding">
            <div className='sm-room-item-content'>
              <div className='sm-room-item-rooms'>
                <div className="sm-room-item" >
                  <strong className="font-14 sm-font-22 room-name margin-end-half no-select-highlight ">{room.name}</strong>
                  {capacity}
                  {!!rate.description && <div className="margin-top-light">{rate.description}</div>}
                </div>
              </div>

              <div className='sm-board-cancellation'>

                <span className="gray-tag font-12 no-wrap margin-bottom-half">
                  <span className="inline-block-middle"> {rate.board.name}</span>
                  <span className="pipe margin-start-light margin-end-light" />
                  <span className="inline-block-middle"> {rate.board.code} </span>
                </span>

                {rate.cancellationPolicy?.status === "Refundable" ?
                  <div className="green green%%%"> قابل استرداد</div>
                  : rate.cancellationPolicy?.status ?
                    <div className="gray-tag font-12">غیر قابل استرداد</div>
                    : null
                }

              </div>
            </div>

          </div>
          <div className="room-item-footer card-padding">
            <div>
              <div className="inline-medium margin-end-half font-12 sm-font-14 xs-margin-bottom-half">
                {Dictionary.totalFor} {duration} {Dictionary.nights}:
              </div>

              <div className="inline-medium">
                {rate.availablityType === 'Completion' ? "--"
                  : prices.roomPrice && prices.roomPrice > 1000 ? (
                    <>
                      {prices.boardPrice && prices.roomPrice < prices.boardPrice && (
                        <div className="old-price inline-medium font-16 sm-font-20 margin-end-half">
                          <Price currency={props.currency} >
                            {props.count * prices.boardPrice}
                          </Price>
                        </div>
                      )}

                      <b className="new-price inline-medium font-16 sm-font-20">
                        <Price currency={props.currency}>
                          {props.count * prices.roomPrice}
                        </Price>
                      </b>
                    </>
                  ) : (
                    <span className="margin-bottom-light purple">قیمت نیازمند استعلام است</span>
                  )}
              </div>

            </div>
            {isSelectedRoom ?
              <span className='green selected-room-message'>
                <span className='itours-icon icon-small check-green margin-end-light' />
                این اتاق انتخاب شد
              </span>
              // <div>
              //   <div className="block medium-inline-block middle text-center margin-bottom-light margin-end-light">تعداد اتاق:</div>
              //   <div className="block medium-inline-block middle">
              //     <QuantityInput min={1} max={rate.available} onChange={props.setCount} value={props.count} className="style-b" />
              //   </div>
              // </div>
              :
              <button
                className="button blue-btn"
                type='buttom'
                onClick={() => { props.selectRoomHandle(room, rate) }}
                disabled={props.reserveLoading}
              >
                انتخاب اتاق
              </button>
            }
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  error: state.VisualData.error,
  Dictionary: state.VisualData.Dictionary,
  currency: state.UserData.Currency,
});

export default connect(mapStateToProps)(DomesticHotelDetailSafarmarketRateItem);